import * as React from 'react'

import type { IncidenceTaskTypesQueryData } from './useGetIncidenceTaskTypes'

type IncidenceTaskTypesQueryContextValue = IncidenceTaskTypesQueryData[]
const incidenceTaskTypesQueryContext = React.createContext<IncidenceTaskTypesQueryContextValue>([])

export const IncidenceTaskTypesProvider = incidenceTaskTypesQueryContext.Provider

export const useIncidenceTaskTypes = (): IncidenceTaskTypesQueryContextValue => {
  const incidenceTaskType = React.useContext(incidenceTaskTypesQueryContext)

  return incidenceTaskType || []
}
